// Copyright (c) 2023 Deere & Company

import actions from '../../actions-list';
import {getDefaultState as getWipDefaultState} from '../state';

const updateDuplicatePinPlateChangesLength = (state, action) => action.length;

export default (state = getWipDefaultState().duplicatePinPlateLength, action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_DUPLICATE_PIN_PLATE_LENGTH]: updateDuplicatePinPlateChangesLength
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/wip/reducers/duplicate-pin-plate-length.js